import React, { useState } from 'react'
import compose from 'recompose/compose'
import moment from 'moment'
import _map from 'lodash/map'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import { RegularSelect, DateInput } from '../../atoms'
import avaiOptions from '../../../utils/status-options'
import statusType from '../../../models/status-type'

const ModalChangeStatus = ({ open, handleClose, i18n, onSubmit, options }) => {
  const [status, setStatus] = useState(-1)
  const [date, setDate] = React.useState(new Date())

  const onChangeStatus = label => {
    label && setStatus(label)
  }
  const onClickSubmit = e => {
    e && e.preventDefault()

    // Devuelve la petición del padre: ActionDialog mantiene el spinner hasta que responde
    return Promise.resolve(onSubmit(status, moment(date).format('YYYY-MM-DD HH:mm:ss'))).then(() => setStatus(-1))
  }

  const onChangeDate = e => setDate(e)
  const newOptions = options?_map(options, ({ id }) => {return {value: id, id, label: i18n.status[id]}}):avaiOptions()
  return (
    <ActionDialog
      open={open}
      title={i18n.modalChangeStatus.changeStatus}
      onClose={handleClose}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalChangeStatus.changeStatus}
      confirmDisabled={status === -1}
      disableBackdropClose
    >
      <S.Body>
        <div>
          <S.Label>{i18n.modalChangeStatus.selectStatus}</S.Label>
          <RegularSelect placeholder={i18n.modalChangeStatus.select} name="availability" options={newOptions} onChange={onChangeStatus} />
        </div>
        {status === statusType.HIRED ? (
          <div>
            <S.Label>{i18n.modalChangeStatus.hiredDate}</S.Label>
            <DateInput name="date" onChange={onChangeDate} value={date} />
          </div>
        ) : null}
      </S.Body>
    </ActionDialog>
  )
}

ModalChangeStatus.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
}

const enharce = compose(withI18n)

export default enharce(ModalChangeStatus)
